import { Outlet, useLocation } from 'react-router-dom'
import 'assets/css/myhub.css';
import { myhubTabs } from 'consts/tabs';
import useActiveItem from 'hooks/useActiveItem';
import MainSort from 'components/main-components/MainSort';
import { useEffect, useState } from 'react';
import usePageItems from 'hooks/usePageItems';
import useFiltersData from 'hooks/useFiltersData';
import { getSortList } from 'consts/sort';
import GradientBlock from 'components/GradientBlock'
import MainTabs from 'components/main-components/MainTabs'
import useFiltersQueryParams from 'hooks/useFiltersQueryParams';

const MyHubRoute = () => {

  const { pathname } = useLocation();
  const {isActiveItem} = useActiveItem();
  const [isFiltersLoading, setIsFiltersLoading] = useState(false);
  const [isItemsLoading, setIsItemsLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState(null);
  const [currentSort, setCurrentSort] = useState({ label: 'Low to high', order: 'low_high' });
  const [paginationData, setPaginationData] = useState({});
  const [offsetCount, setOffsetCount] = useState(0);
  const { searchParams } = useFiltersQueryParams();

  const getOpenedClass = () => {
    if (
      filters ||
      (Array.isArray(items) && items.length > 0) ||
      isActiveItem
    ) {
      return 'opened';
    } else if (!filters && Array.isArray(items) && items.length < 1) {
      return ''
    }
  };

  const outletProps = {
    isFiltersLoading,
    isItemsLoading,
    items,
    filters,
    paginationData,
    offsetCount,
    setOffsetCount,
    getOpenedClass,
  }

  useFiltersData(setFilters, setIsFiltersLoading);
  usePageItems(setItems, setPaginationData, offsetCount, setIsItemsLoading, currentSort.order);

  useEffect(() => {
    if (!pathname.includes('/dashboard')) {
      const pageSort = getSortList(pathname).list[0];
      setCurrentSort(pageSort)
      setOffsetCount(0);
    }
  }, [pathname, searchParams]);

  return (
    <>
      <GradientBlock>
        <MainTabs tabs={myhubTabs} />
        {!pathname.includes('/dashboard') && <MainSort currentSort={currentSort} setCurrentSort={setCurrentSort} setOffsetCount={setOffsetCount} />}
      </GradientBlock>
      <Outlet context={outletProps} />
    </>
  )
}

export default MyHubRoute;
